"use client";

import { Button } from "@/components/ui/button";
import { FaStar } from "react-icons/fa";
import { useAddRatingComment } from "../hooks/useCreateRating";
import { useSession } from "next-auth/react";

interface ReviewDialogProps {
  packageId: string;
}

const ReviewModal = ({ packageId }: ReviewDialogProps) => {
  const productId = packageId;

  const { status } = useSession();
  const isLoggedIn = status === "authenticated";

  const { rating, setRating, formik } = useAddRatingComment({
    id: productId,
  });

  return (
    <>
      {isLoggedIn && (
        <div className="relative w-full max-w-[39.75rem] rounded-2xl bg-white p-6">
          {/* Review Form */}
          <form onSubmit={formik.handleSubmit} className="space-y-5">
            {/* Rating */}
            <div className="flex items-center gap-4">
              <label className="typography-paragraph-medium text-grey-500 font-medium">
                Give a Rating
              </label>
              <div className="mt-1.5 flex gap-2">
                {[1, 2, 3, 4, 5].map((star) => (
                  <FaStar
                    key={star}
                    size={22}
                    className={`cursor-pointer transition-colors ${
                      rating >= star ? "text-yellow-400" : "text-gray-300"
                    }`}
                    onClick={() => setRating(star)}
                  />
                ))}
              </div>
            </div>

            {/* Comment Field */}
            <div className="space-y-2">
              <label
                htmlFor="comment"
                className="typography-paragraph-medium text-grey-500 font-medium"
              >
                Write Review
              </label>
              <textarea
                id="comment"
                name="comment"
                rows={4}
                maxLength={200}
                placeholder="Write Review..."
                className="form-input w-full"
                value={formik.values.comment}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.comment && formik.errors.comment && (
                <p className="text-error typography-paragraph-small">
                  {formik.errors.comment}
                </p>
              )}
              {/* character counter */}
              <div className="text-right text-sm text-gray-500">
                {formik.values.comment.length}/200
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex justify-end gap-3">
              <Button
                type="button"
                variant="outline"
                className="cursor-pointer bg-transparent"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className="cursor-pointer bg-primary-500 text-white hover:bg-primary-600 duration-300"
                disabled={formik.isSubmitting}
              >
                {formik.isSubmitting ? "Submitting..." : "Submit Review"}
              </Button>
            </div>
          </form>
        </div>
      )}
    </>
  );
};

export default ReviewModal;
